<script>
import Layout from "../../../layouts/main";
import PageHeader from "../../../components/page-header";

export default {
  page: {
    title: "Billing Email",
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Billing Email",
      items: [
        {
          text: "Email Template",
          href: "/",
        },
        {
          text: "Billing Email",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <table
          class="body-wrap"
          style="
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
            box-sizing: border-box;
            font-size: 14px;
            width: 100%;
            background-color: transparent;
            margin: 0;
          "
        >
          <tr
            style="
              font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
              box-sizing: border-box;
              font-size: 14px;
              margin: 0;
            "
          >
            <td
              style="
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                box-sizing: border-box;
                font-size: 14px;
                vertical-align: top;
                margin: 0;
              "
              valign="top"
            ></td>
            <td
              class="container"
              width="600"
              style="
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                box-sizing: border-box;
                font-size: 14px;
                vertical-align: top;
                display: block !important;
                max-width: 600px !important;
                clear: both !important;
                margin: 0 auto;
              "
              valign="top"
            >
              <div
                class="content"
                style="
                  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                  box-sizing: border-box;
                  font-size: 14px;
                  max-width: 600px;
                  display: block;
                  margin: 0 auto;
                  padding: 20px;
                "
              >
                <table
                  class="main"
                  width="100%"
                  cellpadding="0"
                  cellspacing="0"
                  style="
                    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                    box-sizing: border-box;
                    font-size: 14px;
                    border-radius: 3px;
                    margin: 0;
                    border: none;
                  "
                >
                  <tr
                    style="
                      font-family: 'Helvetica Neue', Helvetica, Arial,
                        sans-serif;
                      box-sizing: border-box;
                      font-size: 14px;
                      margin: 0;
                    "
                  >
                    <td
                      class="content-wrap aligncenter"
                      style="
                        font-family: 'Helvetica Neue', Helvetica, Arial,
                          sans-serif;
                        box-sizing: border-box;
                        font-size: 14px;
                        vertical-align: top;
                        margin: 0;
                        padding: 20px;
                        color: #495057;
                        border: 2px solid #1d1e3a;
                        border-radius: 7px;
                        background-color: #fff;
                      "
                      align="center"
                      valign="top"
                    >
                      <table
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                        style="
                          font-family: 'Helvetica Neue', Helvetica, Arial,
                            sans-serif;
                          box-sizing: border-box;
                          font-size: 14px;
                          margin: 0;
                        "
                      >
                        <tr
                          style="
                            font-family: 'Helvetica Neue', Helvetica, Arial,
                              sans-serif;
                            box-sizing: border-box;
                            font-size: 14px;
                            margin: 0;
                          "
                        >
                          <td
                            class="content-block"
                            style="
                              font-family: 'Helvetica Neue', Helvetica, Arial,
                                sans-serif;
                              box-sizing: border-box;
                              font-size: 14px;
                              vertical-align: top;
                              margin: 0;
                              padding: 0 0 20px;
                            "
                            valign="top"
                          >
                            <h2
                              class="aligncenter"
                              style="
                                font-family: 'Helvetica Neue', Helvetica, Arial,
                                  'Lucida Grande', sans-serif;
                                box-sizing: border-box;
                                font-size: 24px;
                                color: #000;
                                line-height: 1.2em;
                                font-weight: 400;
                                text-align: center;
                                margin: 40px 0 0;
                              "
                              align="center"
                            >
                              Thanks for using
                              <b
                                style="
                                  font-weight: 600;
                                  text-transform: uppercase;
                                "
                                >Skote</b
                              >.
                            </h2>
                          </td>
                        </tr>
                        <tr
                          style="
                            font-family: 'Helvetica Neue', Helvetica, Arial,
                              sans-serif;
                            box-sizing: border-box;
                            font-size: 14px;
                            margin: 0;
                          "
                        >
                          <td
                            class="content-block aligncenter"
                            style="
                              font-family: 'Helvetica Neue', Helvetica, Arial,
                                sans-serif;
                              box-sizing: border-box;
                              font-size: 14px;
                              vertical-align: top;
                              text-align: center;
                              margin: 0;
                              padding: 0 0 20px;
                            "
                            align="center"
                            valign="top"
                          >
                            <table
                              class="invoice"
                              style="
                                font-family: 'Helvetica Neue', Helvetica, Arial,
                                  sans-serif;
                                box-sizing: border-box;
                                font-size: 14px;
                                text-align: left;
                                width: 80%;
                                margin: 40px auto;
                              "
                            >
                              <tr
                                style="
                                  font-family: 'Helvetica Neue', Helvetica,
                                    Arial, sans-serif;
                                  box-sizing: border-box;
                                  font-size: 14px;
                                  margin: 0;
                                "
                              >
                                <td
                                  style="
                                    font-family: 'Helvetica Neue', Helvetica,
                                      Arial, sans-serif;
                                    box-sizing: border-box;
                                    font-size: 14px;
                                    vertical-align: top;
                                    margin: 0;
                                    padding: 5px 0;
                                  "
                                  valign="top"
                                >
                                  <b>Company Name</b>
                                  <br
                                    style="
                                      font-family: 'Helvetica Neue', Helvetica,
                                        Arial, sans-serif;
                                      box-sizing: border-box;
                                      font-size: 14px;
                                      margin: 0;
                                    "
                                  />Invoice #6521
                                  <br
                                    style="
                                      font-family: 'Helvetica Neue', Helvetica,
                                        Arial, sans-serif;
                                      box-sizing: border-box;
                                      font-size: 14px;
                                      margin: 0;
                                    "
                                  />August 01 2017
                                </td>
                              </tr>
                              <tr
                                style="
                                  font-family: 'Helvetica Neue', Helvetica,
                                    Arial, sans-serif;
                                  box-sizing: border-box;
                                  font-size: 14px;
                                  margin: 0;
                                "
                              >
                                <td
                                  style="
                                    font-family: 'Helvetica Neue', Helvetica,
                                      Arial, sans-serif;
                                    box-sizing: border-box;
                                    font-size: 14px;
                                    vertical-align: top;
                                    margin: 0;
                                    padding: 5px 0;
                                  "
                                  valign="top"
                                >
                                  <table
                                    class="invoice-items"
                                    cellpadding="0"
                                    cellspacing="0"
                                    style="
                                      font-family: 'Helvetica Neue', Helvetica,
                                        Arial, sans-serif;
                                      box-sizing: border-box;
                                      font-size: 14px;
                                      width: 100%;
                                      margin: 0;
                                    "
                                  >
                                    <tr
                                      style="
                                        font-family: 'Helvetica Neue', Helvetica,
                                          Arial, sans-serif;
                                        box-sizing: border-box;
                                        font-size: 14px;
                                        margin: 0;
                                      "
                                    >
                                      <td
                                        style="
                                          font-family: 'Helvetica Neue',
                                            Helvetica, Arial, sans-serif;
                                          box-sizing: border-box;
                                          font-size: 14px;
                                          vertical-align: top;
                                          border-top-width: 1px;
                                          border-top-color: #eee;
                                          border-top-style: solid;
                                          margin: 0;
                                          padding: 5px 0;
                                        "
                                        valign="top"
                                      >
                                        BS-200 (1 Pc)
                                      </td>
                                      <td
                                        class="alignright"
                                        style="
                                          font-family: 'Helvetica Neue',
                                            Helvetica, Arial, sans-serif;
                                          box-sizing: border-box;
                                          font-size: 14px;
                                          vertical-align: top;
                                          text-align: right;
                                          border-top-width: 1px;
                                          border-top-color: #eee;
                                          border-top-style: solid;
                                          margin: 0;
                                          padding: 5px 0;
                                        "
                                        align="right"
                                        valign="top"
                                      >
                                        $10.99
                                      </td>
                                    </tr>
                                    <tr
                                      style="
                                        font-family: 'Helvetica Neue', Helvetica,
                                          Arial, sans-serif;
                                        box-sizing: border-box;
                                        font-size: 14px;
                                        margin: 0;
                                      "
                                    >
                                      <td
                                        style="
                                          font-family: 'Helvetica Neue',
                                            Helvetica, Arial, sans-serif;
                                          box-sizing: border-box;
                                          font-size: 14px;
                                          vertical-align: top;
                                          border-top-width: 1px;
                                          border-top-color: #eee;
                                          border-top-style: solid;
                                          margin: 0;
                                          padding: 5px 0;
                                        "
                                        valign="top"
                                      >
                                        BS-400 (2 Pcs)
                                      </td>
                                      <td
                                        class="alignright"
                                        style="
                                          font-family: 'Helvetica Neue',
                                            Helvetica, Arial, sans-serif;
                                          box-sizing: border-box;
                                          font-size: 14px;
                                          vertical-align: top;
                                          text-align: right;
                                          border-top-width: 1px;
                                          border-top-color: #eee;
                                          border-top-style: solid;
                                          margin: 0;
                                          padding: 5px 0;
                                        "
                                        align="right"
                                        valign="top"
                                      >
                                        $60.00
                                      </td>
                                    </tr>
                                    <tr
                                      style="
                                        font-family: 'Helvetica Neue', Helvetica,
                                          Arial, sans-serif;
                                        box-sizing: border-box;
                                        font-size: 14px;
                                        margin: 0;
                                      "
                                    >
                                      <td
                                        style="
                                          font-family: 'Helvetica Neue',
                                            Helvetica, Arial, sans-serif;
                                          box-sizing: border-box;
                                          font-size: 14px;
                                          vertical-align: top;
                                          border-top-width: 1px;
                                          border-top-color: #eee;
                                          border-top-style: solid;
                                          margin: 0;
                                          padding: 5px 0;
                                        "
                                        valign="top"
                                      >
                                        BS-1000 (1 Pc)
                                      </td>
                                      <td
                                        class="alignright"
                                        style="
                                          font-family: 'Helvetica Neue',
                                            Helvetica, Arial, sans-serif;
                                          box-sizing: border-box;
                                          font-size: 14px;
                                          vertical-align: top;
                                          text-align: right;
                                          border-top-width: 1px;
                                          border-top-color: #eee;
                                          border-top-style: solid;
                                          margin: 0;
                                          padding: 5px 0;
                                        "
                                        align="right"
                                        valign="top"
                                      >
                                        $600.00
                                      </td>
                                    </tr>
                                    <tr
                                      class="total"
                                      style="
                                        font-family: 'Helvetica Neue', Helvetica,
                                          Arial, sans-serif;
                                        box-sizing: border-box;
                                        font-size: 14px;
                                        margin: 0;
                                      "
                                    >
                                      <td
                                        class="alignright"
                                        width="80%"
                                        style="
                                          font-family: 'Helvetica Neue',
                                            Helvetica, Arial, sans-serif;
                                          box-sizing: border-box;
                                          font-size: 14px;
                                          vertical-align: top;
                                          text-align: right;
                                          border-top-width: 2px;
                                          border-top-color: #333;
                                          border-top-style: solid;
                                          border-bottom-color: #333;
                                          border-bottom-width: 2px;
                                          border-bottom-style: solid;
                                          font-weight: 700;
                                          margin: 0;
                                          padding: 5px 0;
                                        "
                                        align="right"
                                        valign="top"
                                      >
                                        Total
                                      </td>
                                      <td
                                        class="alignright"
                                        style="
                                          font-family: 'Helvetica Neue',
                                            Helvetica, Arial, sans-serif;
                                          box-sizing: border-box;
                                          font-size: 14px;
                                          vertical-align: top;
                                          text-align: right;
                                          border-top-width: 2px;
                                          border-top-color: #333;
                                          border-top-style: solid;
                                          border-bottom-color: #333;
                                          border-bottom-width: 2px;
                                          border-bottom-style: solid;
                                          font-weight: 700;
                                          margin: 0;
                                          padding: 5px 0;
                                        "
                                        align="right"
                                        valign="top"
                                      >
                                        $670.99
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr
                          style="
                            font-family: 'Helvetica Neue', Helvetica, Arial,
                              sans-serif;
                            box-sizing: border-box;
                            font-size: 14px;
                            margin: 0;
                          "
                        >
                          <td
                            class="content-block aligncenter"
                            style="
                              font-family: 'Helvetica Neue', Helvetica, Arial,
                                sans-serif;
                              box-sizing: border-box;
                              font-size: 14px;
                              vertical-align: top;
                              text-align: center;
                              margin: 0;
                              padding: 0 0 20px;
                            "
                            align="center"
                            valign="top"
                          >
                            Skote Inc. 2896 Howell Rd, Russellville, AR, 72823
                          </td>
                        </tr>

                        <tr
                          style="
                            font-family: 'Helvetica Neue', Helvetica, Arial,
                              sans-serif;
                            box-sizing: border-box;
                            font-size: 14px;
                            margin: 0;
                          "
                        >
                          <td
                            class="content-block"
                            style="
                              text-align: center;
                              font-family: 'Helvetica Neue', Helvetica, Arial,
                                sans-serif;
                              box-sizing: border-box;
                              font-size: 14px;
                              vertical-align: top;
                              margin: 0;
                              padding: 0;
                            "
                            valign="top"
                          >
                            © 2021 Skote
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </table>
        <!-- end table -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>